module.exports = __webpack_public_path__ + "img/icon_5_82.656c36ee.png";